import React from 'react';

import PropTypes from 'prop-types';

import TextFieldField from './TextFieldField';

const DateTimeField = ({ placeholder, textPlaceholder, ...props }) => (
  <TextFieldField
    {...props}
    placeholder={placeholder || textPlaceholder}
    type="datetime-local"
  />
);

DateTimeField.propTypes = {
  data: PropTypes.shape({ title: PropTypes.string }).isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  isDiff: PropTypes.bool,
  placeholder: PropTypes.string,
  textPlaceholder: PropTypes.string,
  validate: PropTypes.func,
  savedError: PropTypes.string,
  onValidationChange: PropTypes.func,
  onChange: PropTypes.func.isRequired,
};

DateTimeField.defaultProps = {
  value: '',
  disabled: false,
  isDiff: false,
  placeholder: '',
  textPlaceholder: '',
  validate: null,
  savedError: null,
  onValidationChange: null,
};

export default DateTimeField;
